module.exports = __webpack_public_path__ + "static/bb27b33f.sixth-group-img.png";